<template>
  <el-skeleton animated test-id="main">
    <template #template>
      <main class="md:mx-14 mx-4 pt-8 g">
        <div>
          <div class="flex items-center gap-x-4 lg:gap-x-12">
            <el-skeleton-item class="flex items-center h-8 rounded-lg w-20">
            </el-skeleton-item>
            <div class="flex items-center gap-x-2 lg:gap-x-4">
              <el-skeleton-item variant="rect" class="h-5 w-8 rounded-sm" /> >
              <el-skeleton-item variant="text" class="h-5 w-28" />
            </div>
          </div>
          <!--  -->
          <div
            class="mt-8 flex flex-col lg:flex-row lg:items-center justify-between"
          >
            <div>
              <div class="flex gap-x-10 items-center">
                <div>
                  <el-skeleton-item
                    variant="text"
                    class="w-20"
                  ></el-skeleton-item>
                  <h3 class="flex items-center gap-x-7">
                    <el-skeleton-item
                      variant="text"
                      class="w-40 h-5"
                    ></el-skeleton-item>
                    -
                    <span class="flex items-center gap-x-2">
                      <el-skeleton-item
                        variant="rect"
                        class="h-5 w-5 lg:h-7 lg:w-7 rounded-full"
                      />
                      <el-skeleton-item
                        variant="text"
                        class="w-16"
                      ></el-skeleton-item>
                    </span>
                  </h3>
                </div>
                <div>
                  <el-skeleton-item
                    variant="text"
                    class="w-20"
                  ></el-skeleton-item>
                  <div class="flex items-center gap-x-3">
                    <el-skeleton-item
                      variant="text"
                      class="w-20 mt-3"
                    ></el-skeleton-item>
                  </div>
                </div>
              </div>
              <p class="flex items-center gap-x-3 mt-3">
                <el-skeleton-item
                  variant="text"
                  class="w-20 h-5"
                ></el-skeleton-item>
                <span class="flex items-center gap-x-1">
                  <el-skeleton-item
                    variant="text"
                    class="w-20 h-5"
                  ></el-skeleton-item>
                  <el-skeleton-item variant="rect" class="h-3 w-3" />
                </span>
              </p>
            </div>
          </div>
          <!--  -->
          <hr class="border-main my-8" />
          <div class="grid grid-cols-2 gap-5 lg:gap-0 lg:grid-cols-4">
            <div class="flex flex-col">
              <el-skeleton-item
                variant="text"
                class="w-28 h-8"
              ></el-skeleton-item>
              <el-skeleton-item
                variant="text"
                class="w-24 h-5 mt-3"
              ></el-skeleton-item>
              <el-skeleton-item
                variant="text"
                class="w-24 h-5 mt-3"
              ></el-skeleton-item>
            </div>
            <div class="flex-col flex">
              <el-skeleton-item
                variant="text"
                class="w-28 h-8"
              ></el-skeleton-item>
              <el-skeleton-item
                variant="text"
                class="w-24 h-5 mt-3"
              ></el-skeleton-item>
            </div>
            <div>
              <div class="flex-col flex">
                <el-skeleton-item
                  variant="text"
                  class="w-28 h-8"
                ></el-skeleton-item>
                <el-skeleton-item
                  variant="text"
                  class="w-24 h-5 mt-3"
                ></el-skeleton-item>
              </div>
            </div>
          </div>
        </div>
        <!-- beneficiary table -->
        <div v-if="showBeneficiaryTable">
          <div class="flex items-center justify-between mt-10">
            <div class="flex items-center gap-x-3">
              <el-skeleton-item
                variant="text"
                class="w-24 h-5 mt-3"
              ></el-skeleton-item>
              <el-skeleton-item
                variant="text"
                class="w-24 h-5 mt-3"
              ></el-skeleton-item>
            </div>
            <div>
              <el-skeleton-item
                variant="rect"
                class="px-4 w-40 h-8 lg:py-4 py-2.5 flex items-center justify-center gap-x-2 rounded-lg mb-6"
              >
              </el-skeleton-item>
            </div>
          </div>

          <div class="border rounded-lg p-4 w-full overflow-x-auto mt-5">
            <div class="scrollable-container">
              <el-skeleton animated test-id="main">
                <template #template>
                  <div class="">
                    <div class="flex items-center justify-between gap-x-4 mb-5">
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full h-6 mb-3"
                      ></el-skeleton-item>
                    </div>
                    <div v-for="index in 3" :key="index">
                      <el-skeleton-item
                        variant="text"
                        animated
                        class="w-full row-height pb-3 mb-3 border-b"
                      ></el-skeleton-item>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="bg-gray-30 mt-5 py-8 px-11 rounded-lg">
            <div class="bg-white rounded-lg px-8 pt-8 flex flex-wrap">
              <div
                v-for="index in 4"
                :key="index"
                class="w-1/2 sm:w-1/3 2xl:w-1/4 flex flex-col pb-8"
              >
                <el-skeleton-item
                  variant="text"
                  class="w-2/5 mb-3 h-5"
                ></el-skeleton-item>
                <el-skeleton-item
                  variant="text"
                  class="w-2/5 h-5"
                ></el-skeleton-item>
              </div>
            </div>
            <div class="bg-white rounded-lg px-8 mt-4 pt-8 flex flex-wrap">
              <div
                v-for="index in 4"
                :key="index"
                class="w-1/2 sm:w-1/3 2xl:w-1/4 flex flex-col pb-8"
              >
                <el-skeleton-item
                  variant="text"
                  class="w-2/5 mb-3 h-5"
                ></el-skeleton-item>
                <el-skeleton-item
                  variant="text"
                  class="w-2/5 h-5"
                ></el-skeleton-item>
              </div>
            </div>
          </div>
        </div>
      </main>
    </template>
  </el-skeleton>
</template>
<script>
export default {
  computed: {
    showBeneficiaryTable () {
      return this.$store.state.bulkPayout.payoutCount > 1
    }
  }
}
</script>
<style scoped>
.row-height {
  height: 40px;
}
</style>
